import React from 'react';
import { Link } from 'react-router-dom';
import nausLogo from '../assets/naus-logo.jpeg';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '2rem' }}>
          {/* Left Section - Logo and Name */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', maxWidth: '400px' }}>
            <img 
              src={nausLogo} 
              alt="NAUS Logo" 
              style={{ 
                width: '60px', 
                height: '60px', 
                borderRadius: '50%',
                border: '2px solid var(--white)',
                flexShrink: 0
              }}
            />
            <div>
              <h3 style={{ color: 'var(--white)', fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                Association of Urological Surgeons, Nigeria
              </h3>
              <p style={{ color: 'var(--light-green)', fontSize: '0.85rem', margin: 0 }}>
                Advancing urological surgery excellence in Nigeria
              </p>
            </div>
          </div>

          {/* Middle Section - Quick Links */}
          <div style={{ display: 'flex', gap: '3rem' }}>
            <div>
              <h4 style={{ color: 'var(--white)', marginBottom: '1rem', fontSize: '1rem', fontWeight: 'bold' }}>Quick Links</h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '0.5rem' }}>
                  <Link 
                    to="/" 
                    style={{ color: 'var(--light-green)', textDecoration: 'none', fontSize: '0.9rem', transition: 'color 0.3s ease' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = 'var(--white)'}
                    onMouseLeave={(e) => e.currentTarget.style.color = 'var(--light-green)'}
                  >
                    Home
                  </Link>
                </li>
                <li style={{ marginBottom: '0.5rem' }}>
                  <Link 
                    to="/about" 
                    style={{ color: 'var(--light-green)', textDecoration: 'none', fontSize: '0.9rem', transition: 'color 0.3s ease' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = 'var(--white)'}
                    onMouseLeave={(e) => e.currentTarget.style.color = 'var(--light-green)'}
                  >
                    About
                  </Link>
                </li>
                <li style={{ marginBottom: '0.5rem' }}>
                  <Link 
                    to="/membership" 
                    style={{ color: 'var(--light-green)', textDecoration: 'none', fontSize: '0.9rem', transition: 'color 0.3s ease' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = 'var(--white)'}
                    onMouseLeave={(e) => e.currentTarget.style.color = 'var(--light-green)'}
                  >
                    Membership
                  </Link>
                </li>
                <li style={{ marginBottom: '0.5rem' }}>
                  <Link 
                    to="/training" 
                    style={{ color: 'var(--light-green)', textDecoration: 'none', fontSize: '0.9rem', transition: 'color 0.3s ease' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = 'var(--white)'}
                    onMouseLeave={(e) => e.currentTarget.style.color = 'var(--light-green)'}
                  >
                    Training
                  </Link>
                </li>
              </ul>
            </div>
            
            <div>
              <h4 style={{ color: 'var(--white)', marginBottom: '1rem', fontSize: '1rem', fontWeight: 'bold' }}>Resources</h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '0.5rem' }}>
                  <Link 
                    to="/news" 
                    style={{ color: 'var(--light-green)', textDecoration: 'none', fontSize: '0.9rem', transition: 'color 0.3s ease' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = 'var(--white)'}
                    onMouseLeave={(e) => e.currentTarget.style.color = 'var(--light-green)'}
                  >
                    News & Updates
                  </Link>
                </li>
                <li style={{ marginBottom: '0.5rem' }}>
                  <Link 
                    to="/contact" 
                    style={{ color: 'var(--light-green)', textDecoration: 'none', fontSize: '0.9rem', transition: 'color 0.3s ease' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = 'var(--white)'}
                    onMouseLeave={(e) => e.currentTarget.style.color = 'var(--light-green)'}
                  >
                    Contact Us
                  </Link>
                </li>
                <li style={{ marginBottom: '0.5rem' }}>
                  <a 
                    href="https://nju.org.ng/index.php/nju" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={{ color: 'var(--light-green)', textDecoration: 'none', fontSize: '0.9rem', transition: 'color 0.3s ease' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = 'var(--white)'}
                    onMouseLeave={(e) => e.currentTarget.style.color = 'var(--light-green)'}
                  >
                    Our Journal
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Section - Social Media */}
          <div>
            <h4 style={{ color: 'var(--white)', marginBottom: '1rem', fontSize: '1rem', fontWeight: 'bold' }}>Follow Us</h4>
            <div style={{ display: 'flex', gap: '1rem' }}>
              {/* X/Twitter - Official Brand Color */}
              <a 
                href="https://x.com/NAUS_GROUP" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon social-icon-twitter"
                aria-label="Follow us on X (Twitter)"
                title="X (Twitter)"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              
              {/* Instagram - Official Gradient */}
              <a 
                href="https://www.instagram.com/naus_group?igsh=MXg3ZXN4YnR0enIxdw==" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon social-icon-instagram"
                aria-label="Follow us on Instagram"
                title="Instagram"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              
              {/* Facebook - Official Brand Color */}
              <a 
                href="https://www.facebook.com/share/1ANH6DDpAQ/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon social-icon-facebook"
                aria-label="Follow us on Facebook"
                title="Facebook"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </div>
            <p style={{ color: 'var(--light-green)', fontSize: '0.75rem', marginTop: '1rem' }}>
              Stay connected with NAUS
            </p>
          </div>
        </div>
        
        {/* Developer Credit Section */}
        <div style={{ 
          borderTop: '1px solid rgba(255, 255, 255, 0.2)', 
          paddingTop: '1.5rem', 
          marginTop: '2rem', 
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <p style={{ color: 'var(--white)', fontSize: '0.85rem', margin: 0 }}>
            © {new Date().getFullYear()} Association of Urological Surgeons, Nigeria. All rights reserved.
          </p>
          <p style={{ 
            color: 'var(--light-teal)', 
            fontSize: '0.85rem', 
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            <span> Website by</span>
            {/* Replace YOUR_LINKTREE_URL with your actual Linktree link */}
            <a 
              href="https://linktr.ee/tzsena" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ 
                color: 'var(--light-teal)', 
                textDecoration: 'underline',
                fontWeight: 'bold'
              }}
            >
              Sena Atim
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;